const getColumnsIDs = (columns) =>
  columns.reduce((acc, { id, columns = null }) => {
    if (columns) {
      acc = [...acc, ...columns.map(({ id }) => id)]
    } else {
      acc = [...acc, id]
    }

    return acc
  }, [])

const getHiddenColumns = (selectionArr = null, columns) => {
  if (selectionArr === null) {
    return
  }

  let hiddenColumns = {}

  columns.forEach(({ id, hideable = true, columns = null }) => {
    if (columns) {
      const filteredColumns = columns
        .filter(
          ({ id, hideable = true }) => hideable && !selectionArr.includes(id),
        )
        .reduce((a, { id }) => ({ ...a, [id]: id }), {})

      if (Object.keys(filteredColumns).length > 0) {
        hiddenColumns = { ...hiddenColumns, ...filteredColumns }
      }
    } else {
      if (hideable && !selectionArr.includes(id)) {
        hiddenColumns = { ...hiddenColumns, [id]: id }
      }
    }
  })

  return { hiddenColumns }
}

export { getColumnsIDs as getColumnsIDs, getHiddenColumns as getHiddenColumns }
